
import { defineComponent } from 'vue';
import { Field, PaneItem } from './charts';
import numeral from 'numeral';
// import FieldBig1 from '@/views/dashboard/analysis/components/charts/field-big1/index.vue';
// import FieldBig from '@/views/dashboard/analysis/components/charts/field-big/index.vue';
import {
  CaretUpOutlined,
  CaretDownOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from '@ant-design/icons-vue';
import { Pie } from './charts';

export default defineComponent({
  name: 'AreaDeskTop',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    visitData: {
      type: [Array, Object],
      required: true,
    },
  },
  setup() {
    const formatYuan = (val: string | number) => `¥ ${numeral(val).format('0,0')}`;
    const options = {
      tooltip_formatter: (param: any) => {
        return [
          '金额: ' + param.data.v.price + `<hr size=1 style='margin: 3px 0'>`,
          '返利率: ' + param.data.v.fl_rate + '<br/>',
        ].join('');
      },
    };

    return {
      numeral,
      formatYuan,
      options,
    };
  },
  components: {
    Field,
    PaneItem,
    // FieldBig1,
    // FieldBig,
    ArrowUpOutlined,
    ArrowDownOutlined,
    CaretUpOutlined,
    CaretDownOutlined,
    Pie,
  },
});
